export class Concert {
    private static instance: Concert;

    static getInstance(): Concert {
        if (!Concert.instance) {
            Concert.instance = new Concert();
        }
        return Concert.instance;
    }

    private bioBtns: HTMLCollectionOf<Element>;
    private memberBios: any;

    private constructor() {
        this.bioBtns = document.getElementsByClassName("bio-btn");
        this.memberBios = document.getElementsByClassName("member-bio");
        

        for (let i = 0; i < this.bioBtns.length; i++) {
            this.bioBtns[i].addEventListener("click", (e) => {
                // Prevent the click event from propagating to parent elements
                e.stopPropagation();
                this.toggleMemberBio(i);
            });
        }
    }

    private toggleMemberBio(index: number): void {

        const btn = this.bioBtns[index] as HTMLElement;
        const parentItem = btn?.closest('.team-list-item, .team-list-item-v2');
        const memberBio = parentItem?.querySelector('.member-bio') as HTMLElement;
        const bioBtnIcon = btn?.querySelector('svg') as SVGElement;
        
        if (memberBio && memberBio.style.display !== "block") {
            memberBio.style.display = "block";
            if (bioBtnIcon) bioBtnIcon.style.transform = "rotate(-90deg)";
        } else if (memberBio) {
            memberBio.style.display = "none";
            if (bioBtnIcon) bioBtnIcon.style.transform = "rotate(90deg)";
        }
    }
}   
